var render = function render(){var _vm=this,_c=_vm._self._c;return _c('primary-btn',{staticClass:"get-started-btn mb-3",nativeOn:{"click":function($event){return _vm.getStartedAction.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }